import { Chip, Grid, TextField } from "@material-ui/core";
import { Autocomplete, createFilterOptions } from "@mui/material";
import LoadingSpinner from "components/LoadingSpinner";
import { useGetVehiclesQuery } from "features/vehicles/vehicleSlice";
import { IconCar } from "icons";
import { useMemo, useState } from "react";
import { vehicleSelectorStyles } from "./vehicleSelectorStyles";
import { getVehicleOptionLabel, renderVehicleOption } from "./vehicleUtils";

const VehicleSelector = ({
    disableClearable = false,
    selectedVehicle,
    onVehiclesChange,
    multiple = false,
    disabled = false,
    clientId = null,
    lotId = null,
    error = false,
}) => {
    const classes = vehicleSelectorStyles();
    const [open, setOpen] = useState(false);

    const { data: vehicles, error: vehiclesError, isLoading: isLoadingVehicles } = useGetVehiclesQuery({ includeHistory: true, clientId: clientId || undefined });

    const filteredVehicles = useMemo(() => {
        if (isLoadingVehicles) return [];
        const result = (!vehicles?.length) ? []
            : lotId ? vehicles?.filter(v => v.lotId === lotId)
                : vehicles;
        return result;
    }, [isLoadingVehicles, vehicles, lotId]);

    const filterOptions = createFilterOptions({
        ignoreCase: true,
        limit: 30,
    });

    const selectedVehicleObj = selectedVehicle && selectedVehicle.id
        ? filteredVehicles.find(v => v.id === selectedVehicle.vehicleId) || null
        : null;
    const autoCompleteValue = multiple ? (selectedVehicle || []) : selectedVehicleObj;

    return (
                <Grid container>
            <Grid item xs={12}>
                <Autocomplete
                    disableClearable={disableClearable}
                    multiple={multiple}
                    id="vehicle-selector"
                    autoComplete
                    filterSelectedOptions
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    handleHomeEndKeys
                    autoHighlight
                    disabled={disabled}
                    value={autoCompleteValue}
                    options={filteredVehicles || []}
                    loading={isLoadingVehicles}
                    getOptionLabel={getVehicleOptionLabel}
                    filterOptions={filterOptions}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    onChange={(event, newValue) => onVehiclesChange(newValue)}
                    renderOption={renderVehicleOption}
                    renderTags={(value = [], getTagProps) =>
                        value.map((option, index) => (
                            <Chip
                                key={option.id}
                                label={getVehicleOptionLabel(option)}
                                {...getTagProps({ index })}
                                icon={<IconCar width={14} height={14} />}
                            />
                        ))
                    }
                    className={`${classes.autoComplete} ${error ? classes.errorField : ''}`}
                    renderInput={(params) => (
                        <div>
                            <TextField
                                {...params}
                                variant='outlined'
                                fullWidth
                                error={error}
                                onFocus={() => setOpen(true)}
                                onBlur={() => setOpen(false)}
                            />
                            <LoadingSpinner loading={isLoadingVehicles} />
                        </div>
                    )}
                />
            </Grid>
        </Grid>
    );
};

export default VehicleSelector;
